import { render, staticRenderFns } from "./BecTransferPart2.vue?vue&type=template&id=e077882a&"
import script from "./BecTransferPart2.vue?vue&type=script&lang=js&"
export * from "./BecTransferPart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports